import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface QuestionnaireState {
  isProceed: boolean;
  country: {
    name: string;
    eligible: boolean;
    skip: boolean;
  } | null;
  isLoading: boolean;
}

const initialState: QuestionnaireState = {
  isProceed: false,
  country: null,
  isLoading: false,
};

export const questionnaireSlice = createSlice({
  name: "questionnaire",
  initialState,
  reducers: {
    proceed: (state, payload) => {
      state.isProceed = payload.payload
    },
    setCountry: (state, { payload }) => {
      state.country = payload;
    },
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
  },
});

export const { proceed, setCountry, startLoading, stopLoading } =
  questionnaireSlice.actions;

export const selectQuestionnaire = (state: RootState) =>
  state.questionnaire.isProceed;

export default questionnaireSlice.reducer;
